// Cheese data
const cheeses = [
  {
    id: 1,
    name: 'Swiss',
    description: 'Traditional Swiss cheese',
    base_price: 1.50
  },
  {
    id: 2,
    name: 'American',
    description: 'American cheese',
    base_price: 1.50
  },
  {
    id: 3,
    name: 'Cheddar',
    description: 'Sharp cheddar cheese',
    base_price: 1.50
  },
  {
    id: 4,
    name: 'Provolone',
    description: 'Mild provolone cheese',
    base_price: 1.50
  },
  {
    id: 5,
    name: 'Muenster',
    description: 'Creamy muenster cheese',
    base_price: 1.50
  },
  {
    id: 6,
    name: 'Colby',
    description: 'Mild Colby cheese',
    base_price: 1.50
  },
  {
    id: 7,
    name: 'White American',
    description: 'White American cheese',
    base_price: 1.50
  }
];

export default cheeses;